import React, { Component, useCallback } from 'react'
import Dropzone from 'react-dropzone'
import { FieldArray } from 'formik'
import NoValue from '@modules/form/components/NoValue'
import DataTable from '@components/DataTable/DataTable'
import DeleteButton from '@modules/form/components/input/DeleteButton'
import merge from 'lodash/merge'
import { Link } from 'react-router-dom'

import Thumb from '@components/Thumb/Thumb'


export default
  class FileUploadMulti extends Component {

  constructor() {
    super()
    this.state = {
      uploading: [],
    }
  }

  uploadFile = async file => {
    const data = new FormData;
    data.append('file', file)
    return fetch('/api/upload', {
      method: 'POST',
      body: data,
    })
      .then(res => res.json())
  }

  deleteFile = async (id) => {
    return fetch(`/api/upload/${id}`, {
      method: 'DELETE'
    })
    .then(res => res.json())
  };


  onDrop(files, arrayHelpers) {

    const { form, field } = this.props;

    const _uploads = form.values._uploads || [];
    const baseIndex = form.values[field.name].length;

    for (let [idx, file] of files.entries()) {
      // construct object to represent file in field value
      const tempFile = {
        fileName: file.name,
        uploading: true,
      }
      const index = baseIndex + idx;

      // start uploading file and capture promise
      _uploads.push(
        this.uploadFile(file)
          .then(res => {
            arrayHelpers.replace(index, res);
          })
      )

      // add tempFile object to field value
      arrayHelpers.push(tempFile);
    }

    // update form with uploads promises
    form.setFieldValue('_uploads', _uploads)

  }
  rowLinks = (doc, arrayHelpers) => (
    <div className="deleteDoc-container">
      <Link to={doc.path} target="_blank">view</Link>
        <DeleteButton item={doc} onConfirmClick={this.deleteFile} arrayHelpers={arrayHelpers} index={this.props.form.values.documents.indexOf(doc)} />
    </div>
  );

  render() {
    const tableColumns = [
      {
        label: 'Filename',
        getValue: row => row.originalName || row.fileName,
      },
    ]
    const { field, form, isEditing } = this.props;
    const files = form.values[field.name];

    if (!isEditing && !(files && files.length)) {
      return <NoValue />
    }

    return (
      <FieldArray name={field.name}>
        {(arrayHelpers) => (
          <React.Fragment>
            <DataTable
              data={files}
              columns={tableColumns}
              rowLinks={(row) => {
                if (isEditing && row.uploading)
                  return 'uploading';
                else if (row._id)
                  return this.rowLinks(row, arrayHelpers);
              }}
            />
            {
              isEditing &&
              this.renderDropzone(arrayHelpers)
            }
          </React.Fragment>
        )}
      </FieldArray>
    )
  }


  renderDropzone(arrayHelpers) {
    // onFileDialogCancel={::this.onCancel}
    return (
      <Dropzone
        onDrop={files => this.onDrop(files, arrayHelpers)}
      >
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()} className="Dropzone">
            <input {...getInputProps()} />
            <p>Drop files here, or click to select files</p>
          </div>
        )}
      </Dropzone>


    )

  }
}

// export default
// function FileUploadMulti() {
// 	console.log(useCallback);
//   const onDrop = useCallback(function() {
//   	console.log('new');
//   	return true;
//   }, [])
//   const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})

//   return (
//     <div {...getRootProps()}>
//       <input {...getInputProps()} />
//       {
//         isDragActive ?
//           <p>Drop the files here ...</p> :
//           <p>Drag 'n' drop some files here, or click to select files</p>
//       }
//     </div>
//   )
// }



// WEBPACK FOOTER //
// ./src/modules/form/components/input/FileUploadMulti.jsx